import React from 'react';

const CookiesCht = () => {
  return (
    <div className="EN">
      <div>
        <p className="p1">
          <span className="s1">
            什麼是cookie？其用途是什麼？
            <br/>
            cookie是一種小型數據文件，以獨特的匿名代碼形式從網絡服務器發送到您的瀏覽器，然後存儲在您的設備(電腦、智能手機和/或平板電腦)的硬盤上。cookie可能允許正確地使用某個
            互聯網站點(這被稱為技術cookie或必要的cookie)，或者它們可能在用戶在線導航的背景下檢查用戶的偏好，以便提供廣告信息(這被稱為分析性cookie)。
            <br/>
            cookie可能會在一段可變的持續時間內永久存儲在設備上(這被稱為永久cookie)，或者它們可能會在瀏覽器關閉時被刪除，或者是在有限的持續時間存在(這被稱為會話cookie)。cookie
            可能由您正在訪問的網站安裝(這被稱為第一方cookie)，也可能由其他網站安裝(這被稱為第三方cookie)。
            <br/>
            <br/>
            本網站使用的cookie及其使用目的
            <br/>
            本網站使用以下cookie：
            <br/>
            <br/>
            必要的/技術cookies
            <br/>
            這些cookie允許本網站正常運行，從而在用戶第一次訪問時查看相關語言和市場的內容，這就是所述的必要的技術cookie的目的。他們能夠識別用戶連接的國家，並確保用戶每次
            訪問時自動定向到適用於其國家的網站版本。這些cookie是網站運行所必需的。
            <br/>
            <br/>
            cookie列表
            <br/>
            cookie是網站要求瀏覽器在用戶訪問設備時存儲在設備上的少量數據(文本文件)，以便記住用戶的信息，例如他們的首選語言或登錄詳細信息。這些cookie是由我們設置的，被稱為第
            一方cookie。我們還使用第三方cookie(來自您正在訪問的網站以外的域名的cookie)，將其用於廣告和營銷目的。具體而言，我們將cookie和其他跟蹤技術用於以下目的:
          </span>
        </p>
        <br/>
        
        <div className="my-10" >
          <table className="w-full table-auto">
            <thead>
              <tr>
                <td>Cookie子群</td>
                <td>Cookies</td>
                <td>目的</td>
                <td>使用的cookie</td>
                <td>有效期</td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>*.valentino.com</td>
                <td>瀏覽器語言</td>
                <td>默認語言</td>
                <td>第一方</td>
                <td>會話</td>
              </tr>
              <tr>
                <td></td>
                <td>作業系統、瀏覽器類型和版本</td>
                <td>Vcard下載和二維碼生成</td>
                <td>第一方</td>
                <td>會話</td>
              </tr>
              <tr>
                <td></td>
                <td>視窗尺寸</td>
                <td>應用程序響應能力</td>
                <td>第一方</td>
                <td>會話</td>
              </tr>
            </tbody>
          </table>
        </div>

        <br/>
        <p className="p1">
          <span className="s1">
          分析性cookie
          <br/>
          這些cookie用於對用戶瀏覽網站的方式進行統計分析，例如使用的設備、訪問的頁面數量或在瀏覽過程中對特定頁面的點擊次數。這些分析的結果以匿名方式處理，僅用於統計目的。
          然後對有關本網站使用情況的統計匯總分析進行處理。我們只使用跟蹤匿名IP地址的cookie(部分代碼不可見);此類cookie被同化為技術cookie，因為它們不允許進行任何的用戶識別，
          也不需要任何同意即可被使用。
          <br/>
          <br/>
          數據保留
          <br/>
          請注意，每個cookie的壽命都在上面的表格中。由cookie收集的數據將由數據控制方保留最多[請參閱下面的列表]，然後註銷或匿名化。
          <br/>
          Adobe 分析（Adobe Analytics）：37個月
          <br/>
          <br/>
          使用cookie的法律依據
          <br/>
          使用技術cookie(包括匿名分析的cookie)無需徵得同意；因此，對它們的處理基於所有者的合法利益，以提供更好的網站導航和使用。
          <br/>
          <br/>
          您的個人資料如何處理
          <br/>
          您的個人數據將通過自動化工具在嚴格必要的時間內進行處理，以實現收集此類數據的目的(請參閱上表和上述數據保留部分的具體cookie持續時間)。我們採取了具體的安全、技術和
          組織措施，以防止數據丟失、非法或不正確使用和未經授權的訪問。
          <br/>
          <br/>
          用戶反對或編輯cookie的權力
          <br/>
          <br/>
          瀏覽器:
          <br/>
          您可以通過將瀏覽器配置為禁用cookie的方式來反對在您的硬盤上存儲cookie。我們列出了主要瀏覽器的程序如下:
          <br/>
          •	Internet Explorer
          <br/>
          •	Chrome: https://support.google.com/chrome/answer/95647?hl=it
          <br/>
          •	Firefox: https://support.mozilla.org/it/kb/Gestione%20dei%20cookie
          <br/>
          •	Safari: http://support.apple.com/kb/HT1677?viewlocale=it_IT
          <br/>
          <br/>
          然而，在完成上述操作後，一些網頁功能可能無法正常工作。
          <br/>
          <br/>
          數據控制方
          <br/>
          cookie收集的數據的控制方為Valentino S.p.A.，註冊辦事處位於意大利米蘭(MI)的Turati Via 16/18, 20121。Valentino S.p.A.已經任命了一名數據保護官，可以通過以下電子郵件地址
          privacy@valentino.com與其聯繫。有關您個人數據處理的任何信息、投訴和行使下述權利，您也可寫信至Valentino, via Turati 16/18, 20121 Milano以聯繫數據控制方(由法律部門受理，
          該部門被指定接收和管理此類請求，根據Valentino內部程序，此事也牽涉到一些相關部門)。
          <br/>
          <br/>
          誰將獲知與這些數據、其轉移和披露有關的信息
          <br/>
          cookies收集的數據將會並可能會涉及以下內容:
          <br/>
          • 數據控制方的僱員與合作者，以被授權進行數據處理的人的身份行事;而且,
          <br/>
          • 以數據處理者的身份提供技術和組織服務的供應商。
          <br/>
          我們可能會通過使用cookie獲得的數據傳輸到國外，包括歐盟以外的國家，但保證提供適當的保護和防禦。如需獲取有關數據確切位置的信息，請寫信發送至privacy@valentino.com
          與數據控制方聯繫。
          <br/>
          這些數據一般不會以任何方式披露。
          <br/>
          <br/>
          用戶權利
          <br/>
          用戶始終有權從VALENTINO獲得關於其個人數據（即使尚未記錄）是否存在的確認，並以可理解的形式被告知。用戶還有權獲取此類信息：個人數據來源；個人數據處理的目的和方
          法，在電子儀器的幫助下進行數據處理時所應用的邏輯；數據控制方和數據處理器的識別詳細信息；以及可能被傳送其個人資料的人士或人士類別的標識。用戶也有權提出如下要求：
          更新、更正或包含（如用戶有興趣這樣做)個人數據、刪除、轉換為匿名形式或阻止違法處理的個人數據（包括就收集或隨後處理的目的而言無需保留的數據）； 份聲明，說明上述
          操作的內容已向接收數據的各方披露，但證明此類操作不可能或需要使用明顯與受保護權利不成比例的方法的情況除外。用戶還可以要求其數據具有可移植性。此外，用戶有權要求限
          制對其個人資料的處理。
          <br/>
          <br/>
          然而，用戶有權以合法理由部分或全部反對處理與他/她有關的個人數據，即使這與收集的範圍有關。
          <br/>
          <br/>
          您可以行使上述權利，並通過發送電子郵件至privacy@valentino.com聯繫VALENTINO和數據保護官詢問相關信息和有關您個人數據處理的進 步問題(請注意，發送電子郵件請求後我
          們需要獲取發件人地址，這是響應請求和跟蹤請求以及出於法律目的跟蹤電子通信中包含的任何其他個人數據所必需的)。您也可以寫信至VALENTINO, via Turati 16/18, 20121, Milano
          (Italy)，由法務部受理。
          <br/>
          <br/>
          最後請注意，您有權向意大利數據保護局(Garante per la Protezione dei Dati Personali，其地址為:Piazza Venezia, 11,00187 Rome，網址為www.garanteprivacy.it)或您所在國家的其他
          數據保護監管機構提出投訴。
          </span>
        </p>
      </div>
    </div>
  );
};

export default CookiesCht;


